<div class="settlement-detail-sticky-header">
    <span class="text-button-pipe"></span>
    <button (click)="exportPdf()"
            class="btn-text-link export-pdf-button"
            data-cy="settlement-export-pdf">
        <div class="export-pdf-button-icon iwp-icon-iwp_pdf"
             data-cy="settlement-export-pdf-icon"></div>
        {{exportPdfButtonLabel}}
    </button>
    <span class="text-button-pipe"></span>
</div>

<div class="settlement-detail-header" data-cy="settlement-detail-header">
    <span class="label" data-cy="settlement-detail-complaint-no-label">Complaint NO.:</span>
    <span class="value" data-cy="settlement-detail-complaint-no-value">{{$safeNavigationMigration(configuration?.data.complaintCode) | undefinedValue}}</span>
</div>
<div class="settlement-detail-header" data-cy="settlement-detail-header">
    <span class="label" data-cy="settlement-detail-settlement-label">Settlement:</span>
    <span class="value" data-cy="settlement-detail-settlement-value">{{$safeNavigationMigration(configuration?.data.settlementCode) | undefinedValue}}</span>
</div>
<div class="settlement-detail-header-status" [ngClass]="$safeNavigationMigration(configuration?.styleClass)"
     data-cy="settlement-detail-header-status">{{configuration?.data.status.name}}</div>
